var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.status !== "hidden"
    ? _c("portal", { attrs: { to: "modal-container", order: _vm.order } }, [
        _c(
          "div",
          _vm._g(
            _vm._b(
              {
                staticClass: "modal",
                class: ["modal_" + _vm.status],
                on: {
                  animationend: function () {
                    return _vm.toggle()
                  },
                },
              },
              "div",
              _vm.$attrs,
              false
            ),
            _vm.$listeners
          ),
          [
            _c("div", {
              staticClass: "modal__overlay",
              on: {
                click: function () {
                  return !_vm.disable_backdrop_click && _vm.toggle()
                },
              },
            }),
            _c(
              "div",
              {
                staticClass: "modal__content",
                style: { width: _vm.content_width },
              },
              [_vm._t("default")],
              2
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }